// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1C_N4","actionWrap":"style_actionWrap__2cpz6","boxValue":"style_boxValue__2IEOJ","boxWrap":"style_boxWrap__3aQT-","boxWrapActive":"style_boxWrapActive__2bJVh"};